function onlyNumbers(str) {
  return str.toString().replace(/[^\d]/g, '');
}

export { onlyNumbers };
//# sourceMappingURL=helper-only-numbers.esm.js.map
